import CharacterVisualiser from "@src/components/CharacterVisualiser/CharaterVisualiser";
import Loader from "@src/components/Loader/Loader";
import { useCharacterStore } from "@src/stores/characterStore";
import { Character, Version } from "@src/types/global";
import { api } from "@src/utils/axios-instance";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useParams } from "react-router";

const CharactersShow = () => {
    const { getCharacterById, setSelectedVersion } = useCharacterStore(
        (state) => {
            return {
                getCharacterById: state.getCharacterById,
                setSelectedVersion: state.setSelectedVersion,
            };
        },
    );
    const { id } = useParams();
    const characterQuery = useQuery<Character>({
        queryFn: () => getCharacterById(id!),
        queryKey: ["characters", id],
    });
    const { isPending, isError, error } = characterQuery;

    const fetchData = (): Promise<Version[]> =>
        api.get(`/characters/${id}/version/`).then((res) => res.data.data);
    const versionsQuery = useQuery<Version[]>({
        queryKey: ["characters", id, "versions"],
        queryFn: fetchData,
        staleTime: 0,
    });
    useEffect(() => {
        setSelectedVersion(0);
        characterQuery.refetch();
        versionsQuery.refetch();
    }, [id]);
    if (isPending) {
        return <Loader />;
    }

    if (isError) {
        return <span>Error: {error.message}</span>;
    }
    console.log(characterQuery.data);
    return (
        <div>
            {versionsQuery.isSuccess && (
                <CharacterVisualiser
                    characterData={characterQuery.data}
                    queriedVersions={versionsQuery.data}
                />
            )}
        </div>
    );
};
export default CharactersShow;
